import { signApiRequest } from ".";
import { useQuery } from "@tanstack/react-query";

export const getBookingStatus = async ({
  bookingId,
  credentials,
}: {
  bookingId: string;
  credentials: object;
}) => {
  if (bookingId == "") {
    return;
  }
  const signedRequest = await signApiRequest(
    "GET",
    `${import.meta.env.VITE_API_URL}/user/booking?bookingId=${bookingId}`,
    credentials,
    {
      "content-type": "application/json",
    }
  );

  const response = await fetch(signedRequest.endpoint, signedRequest.options);
  const data = await response.json();

  return data;
};

export const useGetBookingStatus = ({
  bookingId,
  enabled,
  credentials,
}: {
  bookingId: string;
  enabled: boolean;
  credentials: object;
}) => {
  const bookingStatusQuery = useQuery({
    queryKey: ["get-booking-status"],
    queryFn: () => getBookingStatus({ bookingId, credentials }),
    enabled,
    refetchInterval: 1000,
    retry: 10,
  });
  return bookingStatusQuery;
};
